<!-- 解决方案 -->
<template>
	<div>
		<div class="imgBg"></div>
		<div class="boxWidth">
			<leftMenu :leftMenu="leftMenuList"  @childClick = 'handleChildClick'></leftMenu>
			<div class="solutionRight">
				<h3 class="title">{{ leftMenuList[iscurLeft].title }}</h3>
				<div class="solutionMain" v-if="iscurLeft == 0">
					<img src="../assets/img/solution/xinxihua1.png" alt="">
					<img src="../assets/img/solution/xinxihua2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 1">
					<img src="../assets/img/solution/AI1.png" alt="">
					<img src="../assets/img/solution/AI2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 2">
					<img src="../assets/img/solution/jungong1.png" alt="">
					<img src="../assets/img/solution/jungong2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 3">
					<img src="../assets/img/solution/sanwei1.png" alt="">
					<img src="../assets/img/solution/sanwei2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 4">
					<img src="../assets/img/solution/XR1.png" alt="">
					<img src="../assets/img/solution/XR2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 5">
					<img src="../assets/img/solution/keshihua1.png" alt="">
					<img src="../assets/img/solution/keshihua2.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 6">
					<p class="mainP">{{$t("digital_p1")}}</p>
					<img src="../assets/img/solution/shapan1.png" alt="">
					<p class="mainP">{{$t("digital_p2")}}</p>
					<p class="mainP">{{$t("digital_p3")}}</p>
					<p class="mainP">{{$t("digital_p4")}}</p>
					<p class="mainP">{{$t("digital_p5")}}</p>
					<p class="mainP">{{$t("digital_p6")}}</p>
					<p class="mainP">{{$t("digital_p7")}}</p>
					<img src="../assets/img/solution/shapan2.png" alt="">
					<p class="mainP">{{$t("digital_p8")}}</p>
					<p class="mainP">{{$t("digital_p9")}}</p>
					<img src="../assets/img/solution/shapan3.png" alt="">
				</div>
				<div class="solutionMain" v-if="iscurLeft == 7">
					<p class="mainP">{{$t("GIS_p1")}}</p>
					<img src="../assets/img/solution/datachuli1.png" alt="">
					<img src="../assets/img/solution/datachuli2.png" alt="">
					<p class="mainP">{{$t("GIS_p2")}}</p>
					<img src="../assets/img/solution/datachuli3.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import leftMenu from './leftMenu.vue'
	export default {
	  components: {leftMenu},
	  data() {
	    return {
			iscurLeft:0
		}
	  },
	  computed: {
			leftMenuList() {
				return this.$t('solutionLeftMenuList'); // 获取翻译的menus
			}
		},
	  watch: {
		'$route.path': {
			handler(newVal, oldVal) {
				//判断newVal有没有值监听路由变化
				this.$nextTick(()=>{
					if (newVal == '/solution') {
						this.iscurLeft = 0//solution.vue leftMenu.vue product.vue 三个文件的iscurLeft变量只是名字一样，都是各自的引用，本质上没有区别
					}
				})
			},
			deep: true
		},
	  },
	  methods:{
		handleChildClick(index){
			this.iscurLeft = index//active class
			sessionStorage.setItem("changeLeftListId", index)//设置session
		}
	  }
	}
</script>
<style scoped lang="scss">
 .imgBg{
	background-image: url('../assets/img/bannersolu.jpg');
 }
 .boxWidth{
	display: flex;
	background-color:#fff ;
	padding:20px;
	border:1px solid #DCDFE6;
	box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
 }

</style>